import BlSwitchAv from './BlSwitchAv.vue'

BlSwitchAv.install = function(Vue) {
  Vue.component(BlSwitchAv.name, BlSwitchAv)
}

export default BlSwitchAv
